/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetOrganizationResponseData,
  GetOrganizationResponseDataFromJSON,
  GetOrganizationResponseDataFromJSONTyped,
  GetOrganizationResponseDataToJSON
} from './GetOrganizationResponseData'

/**
 *
 * @export
 * @interface UpdateOrganizationAvatarResponse
 */
export interface UpdateOrganizationAvatarResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateOrganizationAvatarResponse
   */
  status?: number
  /**
   *
   * @type {GetOrganizationResponseData}
   * @memberof UpdateOrganizationAvatarResponse
   */
  data?: GetOrganizationResponseData
}

export function UpdateOrganizationAvatarResponseFromJSON(json: any): UpdateOrganizationAvatarResponse {
  return UpdateOrganizationAvatarResponseFromJSONTyped(json, false)
}

export function UpdateOrganizationAvatarResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateOrganizationAvatarResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetOrganizationResponseDataFromJSON(json['data'])
  }
}

export function UpdateOrganizationAvatarResponseToJSON(value?: UpdateOrganizationAvatarResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetOrganizationResponseDataToJSON(value.data)
  }
}
